export function formatCurrency(value) {
  return Number(value || 0).toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
  });
}

export function formatRequestedAt(dateValue, timeValue) {
  if (!dateValue) {
    return "Not set";
  }

  if (!timeValue) {
    return dateValue;
  }

  return `${dateValue} at ${String(timeValue).slice(0, 5)}`;
}

export function formatTimeSince(value) {
  if (!value) {
    return "";
  }

  const elapsedMilliseconds = Date.now() - new Date(value).getTime();
  const elapsedMinutes = Math.max(1, Math.floor(elapsedMilliseconds / 60000));

  if (elapsedMinutes < 60) {
    return `${elapsedMinutes}m ago`;
  }

  if (elapsedMinutes < 1440) {
    return `${Math.floor(elapsedMinutes / 60)}h ago`;
  }

  return `${Math.floor(elapsedMinutes / 1440)}d ago`;
}

export function getResults(payload) {
  return payload?.results || payload || [];
}